import {
  forwardRef,
  type HTMLAttributes,
  type TdHTMLAttributes,
  type ThHTMLAttributes,
} from "react";

import { cx } from "./cx";
import styles from "./table.module.css";

export const Table = forwardRef<
  HTMLTableElement,
  HTMLAttributes<HTMLTableElement>
>(({ className, ...props }, ref) => (
  <div className={styles.wrapper}>
    <table ref={ref} className={cx(styles.table, className)} {...props} />
  </div>
));
Table.displayName = "Table";

export const TableHeader = forwardRef<
  HTMLTableSectionElement,
  HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => (
  <thead ref={ref} className={cx(styles.head, className)} {...props} />
));
TableHeader.displayName = "TableHeader";

export const TableBody = forwardRef<
  HTMLTableSectionElement,
  HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => (
  <tbody ref={ref} className={cx(styles.body, className)} {...props} />
));
TableBody.displayName = "TableBody";

export const TableRow = forwardRef<
  HTMLTableRowElement,
  HTMLAttributes<HTMLTableRowElement>
>(({ className, ...props }, ref) => (
  <tr ref={ref} className={className} {...props} />
));
TableRow.displayName = "TableRow";

export const TableHead = forwardRef<
  HTMLTableCellElement,
  ThHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => (
  <th ref={ref} className={cx(styles.headCell, className)} {...props} />
));
TableHead.displayName = "TableHead";

export interface TableCellProps extends TdHTMLAttributes<HTMLTableCellElement> {
  /** Column name shown as the row label when the table is in mobile card mode. */
  label?: string;
}
export const TableCell = forwardRef<HTMLTableCellElement, TableCellProps>(
  ({ className, label, ...props }, ref) => (
    <td
      ref={ref}
      className={cx(styles.cell, className)}
      data-label={label}
      {...props}
    />
  ),
);
TableCell.displayName = "TableCell";

export interface TableEmptyProps extends TdHTMLAttributes<HTMLTableCellElement> {
  colSpan: number;
}
export const TableEmpty = forwardRef<HTMLTableCellElement, TableEmptyProps>(
  ({ className, colSpan, children, ...props }, ref) => (
    <tr className={styles.emptyRow}>
      <td
        ref={ref}
        colSpan={colSpan}
        className={cx(styles.empty, className)}
        {...props}
      >
        {children}
      </td>
    </tr>
  ),
);
TableEmpty.displayName = "TableEmpty";
